import { render, staticRenderFns } from "./MobileNavBar.vue?vue&type=template&id=70dd56e4&"
import script from "./MobileNavBar.vue?vue&type=script&lang=js&"
export * from "./MobileNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70dd56e4')) {
      api.createRecord('70dd56e4', component.options)
    } else {
      api.reload('70dd56e4', component.options)
    }
    module.hot.accept("./MobileNavBar.vue?vue&type=template&id=70dd56e4&", function () {
      api.rerender('70dd56e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NavBars/MobileNavBar.vue"
export default component.exports